import { cn } from '@/lib/utils';

/**
 * Discoverability card used by the Inspiration-Tab "Hast du schon
 * entdeckt?" section (Batch 10 Sub-phase C). Visual treatment is
 * symmetric with TipSection (white card, yellow border, 16px padding,
 * rounded-lg) so the Inspiration page reads as one cohesive surface,
 * but the API differs: FeatureCard's lead element is an emoji
 * (visual hook), not a heading-only string.
 *
 * Per Sebastian Gate-1 verbatim lock 2026-04-27 + Decision #3 —
 * Mai-Launch hardcoded flat list, no backend tracking, no
 * personalization. Tap-affordance intentionally absent: these cards
 * are passive content (Briefing Kap. 5 line 770).
 */
export interface FeatureCardProps {
  /** Lead emoji rendered inside the card. */
  emoji: string;
  /** Card title — short noun-phrase, font-semibold. */
  title: string;
  /** Body copy — opacity-50 per Sönke secondary-text convention. */
  body: string;
  className?: string;
  testId?: string;
}

export function FeatureCard({ emoji, title, body, className, testId }: FeatureCardProps) {
  return (
    <div
      className={cn(
        'flex w-full flex-col items-start gap-3 rounded-lg border border-dream-gold bg-dream-white p-4',
        className,
      )}
      data-testid={testId}
    >
      <span aria-hidden className="text-2xl leading-none">
        {emoji}
      </span>
      <div className="flex w-full flex-col items-start gap-2">
        <p className="text-sm font-semibold leading-[14px] text-dream-navy">{title}</p>
        <p className="w-full text-xs leading-5 text-dream-navy opacity-50">{body}</p>
      </div>
    </div>
  );
}
